import { ShareBaseItemComments } from 'phoenix/domain/sharebase-comment';
import { PhoenixUser } from 'phoenix/domain';
import { CommentsService } from 'sharebase/services/commentsService';
import { IUserHistoryDataStore } from 'sharebase/dataStores/userHistoryDataStore';
import { PendingActionsService } from 'sharebase/services/pendingActionsService';

require('./mentionsInput.styles');
const template = require('./mentionsInput.template');

/**
 * Interface for any additional methods that get defined on the controller in the link function.
 */ 
interface LinkController extends MentionsInputController {
    insertMention(user:PhoenixUser): void;
    insertRecentMention(user:PhoenixUser): void;
    addComment(): void;
}

export function MentionsInputDirective(
    $interval:ng.IIntervalService, 
    $timeout:ng.ITimeoutService, 
    $q:ng.IQService, 
    pxEnvironmentService,
    sbCommentsService:CommentsService, 
    sbUserHistoryDataStore:IUserHistoryDataStore
):ng.IDirective  {
    return {
        restrict: 'E',
        controller:  MentionsInputController,
        controllerAs: 'vm',
        bindToController:  true,
        template: template,
        scope : {
            comments: '@',
            placeholder: '@',
            comment: '=',
            addComment: '&'
        },
        link
    };

    function link(scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, vm:LinkController){
        const mentionPattern = /@[\S]+\s?[\S]*/gi;
        const mentionStartedPattern = / @|^[@]/gi;
        var lastChar:string;
        var previousMention:string;
        var textarea: HTMLTextAreaElement;
        var userList: HTMLElement
        var mentionWrapper: HTMLElement;
        var cancelable: ng.IDeferred<any>;
        var selectedIndex = 0;

        var userListFocused:boolean = false; //used to flag user list interaction status
        let resolvePendingStatus:() => void;        

        scope.$watch('vm.comment', (newVal:string, oldVal:string) => {
            if (newVal.length > 0 && oldVal.length === 0) {
                resolvePendingStatus = vm.sbPendingActionsService.addMessage(vm.pendingMessage, 'Unsubmitted comments');
            }
            else if (newVal.length === 0 && resolvePendingStatus) {
                resolvePendingStatus();
            }
        });

        scope.$on('$destroy', () => {
            if (resolvePendingStatus) {
                resolvePendingStatus();
            };
        });

        vm.insertMention = (user:PhoenixUser) => {
            setDropdown();
            replaceMention(textarea, vm.lastMention, user);
            sbUserHistoryDataStore.addToHistory(user);
            refocusTextarea();
        }

        vm.insertRecentMention = (user:PhoenixUser) =>{
            setDropdown();
            replaceMention(textarea, '', user);
            sbUserHistoryDataStore.addToHistory(user);
            refocusTextarea();
        }

        //update the components height to match the input, fixes flex issues
        
        scope.$watch(
            function(){
                let input = element[0].querySelector('.sb-mention__input');
                return input ? angular.element(input).css('height') : '0';
            },
            function(newVal){
                newVal = newVal.replace('px', '');
                element.css('minHeight',parseInt(newVal) + 12 + 'px');  //12 is the padding of the input
            });
            
        onDomReady(() => element.find('textarea')[0])
            .then(elem => {
                textarea = elem as HTMLTextAreaElement;
                userList = element[0].querySelector('.sb-mention__list-wrap') as HTMLElement;
                mentionWrapper = element[0].querySelector('.sb-mention') as HTMLElement;

                //textarea events
                angular.element(textarea)
                    .on('blur', onBlur)
                    .on('keypress', onKeyPress)
                    .on('keydown', onKeyDown)
                    .on('keyup', onKeyUp)
                    .on('click', onClick);
                
                //user list events
                angular.element(userList)
                    .on('mouseenter', onListEnter)
                    .on('mouseleave', onListLeave);

                scope.$on('$destroy', () => {
                    angular.element(textarea)
                        .off('blur', onBlur)
                        .off('keypress', onKeyPress)
                        .off('keydown', onKeyDown)
                        .off('keyup', onKeyUp)
                        .off('click', onClick);
                    
                    angular.element(userList)
                        .off('mouseenter', onListEnter)
                        .off('mouseleave', onListLeave);
                });
                
            });

        function onKeyUp(e: JQueryEventObject){
            switch(e.keyCode) {
                // up || dn || ret || shift
                case 38:
                case 40:
                case 13:
                case 16:                         
                    break;
                default:
                    invokeTypeAhead();
                    break;
           }
        }

        function onBackspace(e: JQueryEventObject) {
            let textarea = e.target as HTMLTextAreaElement;
            let text = textarea.value;
            let start = textarea.selectionStart;
            let end = textarea.selectionEnd;
            $timeout(() => {
                sbCommentsService.removeMention(text, start, end);
            }, 0);
        }

        function invokeTypeAhead(){
            var mentionText;
            if(cancelable) {
                cancelable.resolve('canceled');
            }

            cancelable = $q.defer();

            mentionText = getMention(textarea);

            if(mentionText){
                vm.searchUsers(mentionText, cancelable.promise)
                  .catch(angular.noop);
                vm.showRecents = false;
            }
            else if(vm.mentionStarted) {
                //show user history
                vm.users = sbUserHistoryDataStore.users;

                vm.showRecents = vm.users.length > 0 ? true : false;
                setDropdown(!vm.showRecents);
            }
            else {
                setDropdown(true);
                vm.showRecents = false;
            }
            scope.$digest();
        }

        function onKeyDown(e: JQueryEventObject) {
            let textarea = e.target as HTMLTextAreaElement;

            var isUp = e.keyCode === 38;
            var isDown = e.keyCode === 40;
            var isReturn = e.keyCode === 13;
            var isLeft = e.keyCode === 37;
            var isRight = e.keyCode === 39;

            var isWindows = pxEnvironmentService.isWindows;

            if (isReturn && (e.ctrlKey || (e.metaKey && !isWindows))) {
                e.stopPropagation();
                e.preventDefault();
                vm.addComment();
            }
            
            if(isReturn && textarea.value === ''){ 
                e.stopPropagation();
                e.preventDefault();
                return;
            }

            if (e.keyCode === 8 || (textarea.selectionStart != textarea.selectionEnd && !(isUp || isDown || isLeft || isRight))) {
                // if the user has a selection, we are assuming they are typing over it
                // which could possibly affect a mention, so handle it as a delete.
                onBackspace(e);
                return;
            }

            if(!vm.dropdownOpen) { 
                return;
            }

            if (isUp || isDown || isReturn) { 
                e.stopPropagation();
                e.preventDefault();

                if(isUp || isDown) {
                    selectedIndex = isDown ? 
                        Math.min(++selectedIndex, vm.users.length - 1) :
                        Math.max(--selectedIndex, 0);

                    vm.selectedMention = vm.users[selectedIndex];
                    element[0].querySelector('.selected').scrollIntoView(true);
                }
                else if(vm.selectedMention){
                    vm.insertMention(vm.selectedMention);
                }

                scope.$digest();
            }
        }

        function onKeyPress(e: JQueryEventObject) {
            lastChar = e.key;
        }

        function onBlur(e: JQueryEventObject) {            
            if(!userListFocused){
                //only close if focus is out of the user list
                setDropdown();
            }
        }

        function onListEnter(e: JQueryEventObject) {            
            userListFocused = true;
        }
        function onListLeave(e: JQueryEventObject) {
            userListFocused = false;
        }

        function onClick() {
            invokeTypeAhead();
        }

        function getMention(textarea: HTMLTextAreaElement) {     
            var caretPos = textarea.selectionStart;
            var selectionText = textarea.value;  
            var matches = selectionText.match(mentionPattern) || [];
            vm.mentionStarted = selectionText.match(mentionStartedPattern) != null;
            var mention =  matches.length > 0  ? matches.reduce(function(previousVal, currentVal){                
                var selectionStart = selectionText.indexOf(currentVal)
                var match = previousVal;
                var caretWithinMatch = caretPos >= selectionStart && 
                    caretPos <= (selectionStart + currentVal.length);

                // don't consider matches past the first encountered
                if(!previousVal && selectionStart >= 0 && caretWithinMatch) {
                    match = currentVal;
                } 

                return match;
            }, '') : '';
    
            return mention.replace('@','').trim();
        }

        function replaceMention(textarea: HTMLTextAreaElement, mentionText: string, user:PhoenixUser){
            var $textarea = angular.element(textarea);
            var selectionText:string = $textarea.val().toString();            
            $textarea.val(sbCommentsService.replaceMention(selectionText, `@${mentionText}`, user));
            vm.comment = $textarea.val().toString();
        }

        function setDropdown(close:boolean = true) {
            //set the position of suggestions
            vm.suggestionsStyle = {bottom:mentionWrapper.clientHeight - 16 + 'px'};
            $timeout(function(){
                vm.dropdownOpen = !close;
                if(close){
                    vm.selectedMention = null;
                }
            },100);
        }
        
        function refocusTextarea() {
            angular.element(textarea).focus();
        }
    }

    function onDomReady(predicate: () => HTMLElement, maxTries: number = 10): ng.IPromise<HTMLElement>{        
        return $q((resolve, reject) => {
            var count = 0;
            var element:HTMLElement;
            var i = $interval(() => {
                element = predicate();
                if(element || count >= maxTries) {
                    $interval.cancel(i);
                    i = null;
                    if(element) {
                        resolve(element);       
                    }
                    else {
                        reject(new Error('Failed to deem DOM ready.'));
                    }            
                } 
                count++;
            }, 100);
        });
    }
};

MentionsInputDirective.$inject = [
    '$interval', 
    '$timeout',
    '$q',
    'pxEnvironmentService',
    'sbCommentsService',
    'sbUserHistoryDataStore'
];
class MentionsInputController  {
    public static $inject = [
        '$q', 
        '$http', 
        'pxUriPathService',
        'sbPendingActionsService',
        'gettextCatalog'
    ];
    public dropdownOpen:boolean = false;
    public selectedMention:PhoenixUser;
    public lastMention:string;
    public users:PhoenixUser[] = [];
    public placeholder:string;
    public comment:string;
    public suggestionsStyle: Object;
    public mentionStarted:boolean;
    public showRecents:boolean;
    public pendingMessage:string = this.gettextCatalog.getString('You have unsubmitted comments.');

    public constructor(
        private $q: ng.IQService,
        private $http: ng.IHttpService,
        private pxUriPathService,
        public sbPendingActionsService:PendingActionsService,
        private gettextCatalog:any        
    ){
    }

    public searchUsers(searchPhrase:string, cancelPromise?: ng.IPromise<any>) {
        var self = this;
        var p: ng.IPromise<PhoenixUser[]>;
        if(!searchPhrase) {
            p = this.$q.resolve([]);
        } else if(searchPhrase === this.lastMention) {
            p = this.$q.resolve(this.users);
        } else {       
            this.lastMention = searchPhrase;     
            let uri = this.pxUriPathService.resolvePath("/{system}/users/typeahead?filter={filter}", { 
                filter:  encodeURIComponent(searchPhrase)
            });
            p = this.$http
                .get(uri, {
                    timeout: cancelPromise
                })
                .then(resp => resp.data as PhoenixUser[]);
        }

        return p.then(users => {
            self.dropdownOpen = true;
            if(users.length > 0){
                self.selectedMention = users[0];
            }
            return self.users = users
        });
    }
}


// WEBPACK FOOTER //
// ./src/sharebase/components/mentionsInput/mentionsInput.component.ts